jQuery(document).ready(function ($) {
  $(".bnr_slide").slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  // ROLL LABELS SLIDER
  $(".RollLabels .roll-list").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0724/4683/7016/files/left-arrow.svg?v=1681968488" alt="Previous" width="29.25" height="29.25">/button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0724/4683/7016/files/right-arrow.svg?v=1681968488" alt="Next" width="29.25" height="29.25"></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // INFOGRAPHIC SLIDER
  $(".info_slid").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Fav’s of the Beast SLIDER
  $(".fav-beaset_slid").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    pauseOnHover: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0724/4683/7016/files/left-arrow.svg?v=1681968488" alt="Previous" width="29.25" height="29.25">/button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0724/4683/7016/files/right-arrow.svg?v=1681968488" alt="Next" width="29.25" height="29.25"></button>',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // CONTACT FORM PHONE NUMBER FORMAT VALIDATION
  $('#ContactForm-phone').keydown(function (e) {
       var key = e.charCode || e.keyCode || 0;
       $text = $(this); 
       if (key !== 8 && key !== 9) {
         if ($text.val().length === 3) {
             $text.val($text.val() + '-');
         }
         if ($text.val().length === 7) {
             $text.val($text.val() + '-');
         }
       }
       return (key == 8 || key == 9 || key == 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105));
   });
   
// new product slider
    $('.new-hero-bottom-product-wrap').slick({
    dots: true,
     arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      } 
    ]
    });

  


  
});

// HEADER
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
console.log(items);
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

// FOOTER ACCORDIAN FOR MOBILE
window.addEventListener("DOMContentLoaded", () => {
  if (window.matchMedia("(min-width: 750px)").matches) {
    return;
  }
  const handleCollapse = (heading) => {
    if (heading.classList.contains("block-collapsed")) {
      heading.classList.remove("block-collapsed");
      heading.setAttribute("aria-expanded", "true");
    } else {
      heading.classList.add("block-collapsed");
      heading.setAttribute("aria-expanded", "false");
    }
  };
  document
    .querySelectorAll(".grid .footer-block--menu .footer-block__heading ")
    .forEach((heading, index) => {
      heading.classList.add("block-collapsed");
      heading.setAttribute("role", "button");
      heading.setAttribute("aria-expanded", "false");
      heading.setAttribute("tabindex", "0");
      heading.nextElementSibling.setAttribute(
        "id",
        `footer-block-index-${index}`
      );
      heading.setAttribute("aria-controls", `footer-block-index-${index}`);
      heading.addEventListener("click", () => {
        handleCollapse(heading);
      });
      heading.addEventListener("keypress", () => {
        handleCollapse(heading);
      });
    });
});

// ANCHOR LINK SMOOTH SCROLL
$(document).on("click", "#ContactForm button", function (event) {
  $("html, body").animate({
    scrollTop: $("input:required").offset().top - 180
  });
});


// PRODUCT CARD SLIDER
$(window).on("load", function () {
  if($('.w-slider-mask').length){
    $('.w-slider-mask').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1
    });
  }
  // equalheight('.template-index .new-hero-bottom-product-list')

  equalheight('.equal_height');
});

$(window).on('resize', function(){
    equalheight('.equal_height');
});

// $(window).resize(function(){
//   equalheight('.template-index .new-hero-bottom-product-list');
// });


// equalheight = function(container) {

//   var currentTallest = 0,
//     currentRowStart = 0,
//     rowDivs = new Array(),
//     $el,
//     topPosition = 0;
//   console.log("container",container)
//   $(container).each(function() {

//     $el = $(this);
//     $($el).height('auto')
//     topPostion = $el.position().top;

//     if (currentRowStart != topPostion) {
//       for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
//         rowDivs[currentDiv].height(currentTallest);
//       }
//       rowDivs.length = 0; // empty the array
//       currentRowStart = topPostion;
//       currentTallest = $el.height();
//       rowDivs.push($el);
//     } else {
//       rowDivs.push($el);
//       currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
//     }
//     for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
//       rowDivs[currentDiv].height(currentTallest);
//     }
//   });
// }

equalheight = function(container){
    var currentTallest = 0, currentRowStart = 0, rowDivs = new Array(), $el, topPosition = 0;
    $(container).each(function() {
        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;
        if (currentRowStart != topPostion) {
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) { rowDivs[currentDiv].outerHeight(currentTallest); } 
            rowDivs.length = 0; // empty the array 
            currentRowStart = topPostion; 
            currentTallest = $el.height(); 
            rowDivs.push($el);
        } else {
            rowDivs.push($el); 
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest); 
        }
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) { rowDivs[currentDiv].height(currentTallest); } 
    });
}
